import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import { Badge } from '@mui/material';
import classnames from 'classnames/bind';
import useIsMobile from 'lib/useIsMobile';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    borderRadius: 0,
    color: theme.palette.text.primary,
  },
  heading: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(17),
    fontWeight: theme.typography.fontWeightRegular,
  },
  accordion: {
    borderRadius: 1000,
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(14),
  },
  accordionSummary: {
    color: theme.palette.text.primary,
    // padding: 0,
  },
  span: {
    paddingLeft: 15,
  },
}));

export default function SimpleAccordion({
  comps,
  title,
  incompleteActivitiesCount,
  ...props
}) {
  const mobile = useIsMobile();
  const classes = useStyles();
  const cx = classnames.bind(classes);
  // const [expanded, setExpanded] = React.useState(false);

  // const handleChange = (panel) => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };

  return (
    <div className={classes.root}>
      <Accordion className={classes.accordion} {...props}>
        <AccordionSummary
          className={cx({ accordionSummary: mobile })}
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1bh-content'
          id='panel1bh-header'
        >
          <Typography className={classes.heading}>
            {title}
            {title === 'COMPLETE YOUR ACTIVITIES' ? (
              <Badge
                badgeContent={incompleteActivitiesCount || '0'}
                color='primary'
                className={classes.span}
              />
            ) : null}
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ padding: 16, paddingTop: 0 }}>
          {comps}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
SimpleAccordion.propTypes = {
  comps: PropTypes.object.isRequired,
  title: PropTypes.string,
  incompleteActivitiesCount: PropTypes.number,
};
